up.compiler(
  '[data-lazyload-background-image]',
  (element: HTMLElement, { image }: { image: string }) => {
    function loadBackgroundImageOnIntersection(
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ): void {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          ;(entry.target as HTMLElement).style.backgroundImage = `url("${image}")`
          observer.unobserve(entry.target)
        }
      })
    }

    const observer = new IntersectionObserver(loadBackgroundImageOnIntersection, {
      rootMargin: '100px',
    })
    observer.observe(element)

    return () => {
      observer.unobserve(element)
    }
  },
)
